import { render, staticRenderFns } from "./fuzhen.vue?vue&type=template&id=b55641fc&scoped=true&"
import script from "./fuzhen.vue?vue&type=script&lang=js&"
export * from "./fuzhen.vue?vue&type=script&lang=js&"
import style0 from "./fuzhen.vue?vue&type=style&index=0&id=b55641fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55641fc",
  null
  
)

export default component.exports